import React from 'react';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';
import { ProductStatsContainer } from './styles.js';
import VodStats from 'components-v3/ProductStats/vod/VodStats.jsx';
import { ON_DEMAND_PRODUCT } from 'constants/products.js';

const ProductStats = () => {
  const { selectedProduct } = useProductDataOutsideRoutes();

  if (selectedProduct !== ON_DEMAND_PRODUCT) return null;

  return (
    <ProductStatsContainer layout>
      { selectedProduct === ON_DEMAND_PRODUCT && <VodStats /> }
    </ProductStatsContainer>
  );
};

export default ProductStats;
